import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=0a96ec93&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a96ec93')) {
      api.createRecord('0a96ec93', component.options)
    } else {
      api.reload('0a96ec93', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=0a96ec93&", function () {
      api.rerender('0a96ec93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22A76H66ogMlr/JS/cancellationPolicy.vue"
export default component.exports